import { view } from "@/mega-ui/helpers/function"

export const notFound = {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => view('errors/NotFoundErrorView')
}